import React, { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import LoaderWrapper from "../../../../components/Loaders/LoaderWrapper";
import OnLoadError from "../../../../components/UI/OnLoadError";
import useAudience from "../../../../swr/hooks/Audience/useAudience";
import useGlobalStore from "src/store/useGlobalStore";

const RetailAudience = lazy(() => import("./retail/index.js"));
const VendorAudience = lazy(() => import("./vendor/index.js"));

const AudienceDetail = ({ match }) => {
  const { id } = match.params;
  const setSnackbarText = useGlobalStore((state) => state.setSnackbarText);

  const { data, isLoading, mutate, isError } = useAudience(id);

  if (isLoading) {
    return <LoaderWrapper text="Audience Details" />;
  }

  if (isError) {
    return <OnLoadError />;
  }

  if (data.audience.mappingType === "vendor") {
    return (
      <>
        <Helmet title="Spiffy | Custom Audience" />
        <Suspense fallback={<span />}>
          <VendorAudience
            data={data}
            setSnackbarText={setSnackbarText}
            id={id}
            mutate={mutate}
          />
        </Suspense>
      </>
    );
  }

  const { audience } = data;

  return (
    <>
      <Helmet title="Spiffy | Audience Template" />
      <Suspense fallback={<span />}>
        <RetailAudience audience={audience} mutate={mutate} />
      </Suspense>
    </>
  );
};

export default AudienceDetail;
